import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgTimeSolid = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 6.5,
		fill: "#4384F5",
		stroke: "#4384F5"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8 4V8.5L11 10",
		stroke: "white"
	})]
});
export default SvgTimeSolid;
